import React from "react";
import { CENTER_ITEMS } from "../../../utils/GlobalConstants";
import { FALLBACK_TEXT } from "../../../utils/GlobalMessageConstants";

const FallBack = () => {
  return (
      <div style={CENTER_ITEMS}>
      <p>{FALLBACK_TEXT}</p>
      </div>
  );
};
export default FallBack;
